import { render, staticRenderFns } from "./TrangDanhSachNhomChucVu.vue?vue&type=template&id=05895d3e&"
import script from "./TrangDanhSachNhomChucVu.vue?vue&type=script&lang=js&"
export * from "./TrangDanhSachNhomChucVu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports